import { render, staticRenderFns } from "./TypeaheadSearch.vue?vue&type=template&id=383ba91c&scoped=true&"
import script from "./TypeaheadSearch.vue?vue&type=script&lang=ts&"
export * from "./TypeaheadSearch.vue?vue&type=script&lang=ts&"
import style0 from "./TypeaheadSearch.vue?vue&type=style&index=0&id=383ba91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ba91c",
  null
  
)

export default component.exports